export default "__VITE_ASSET__1898ed40__"